export const ADMIN_BALANCES_WITHDRAWAL_ROUTE_NAME = Symbol('admin.balances.withdrawal');
